<script setup lang="ts">
interface Props {
  title?: string
  width?: string | number
  alignCenter?: boolean
}

withDefaults(defineProps<Props>(), {
  width: '520px',
  alignCenter: false,
})

const model = defineModel<boolean>()
</script>

<template>
  <ElDialog
    v-model="model"
    :title
    :width
    :align-center="alignCenter"
    class="c-dialog"
  >
    <!-- Header -->
    <template #header>
      <slot name="header" />
    </template>

    <!-- Divider -->
    <ElDivider class="!mt-0 !mb-4 !w-[calc(100%+32px)] !-translate-x-4" />

    <!-- Content -->
    <slot />

    <!-- Divider -->
    <ElDivider class="!mb-0 !mt-4 !w-[calc(100%+32px)] !-translate-x-4" />

    <!-- Footer -->
    <template #footer>
      <slot name="footer" />
    </template>
  </ElDialog>
</template>

<style>
/* ElDialog is teleported outside this component's scope,
   so the override is intentionally global. */
.el-dialog.c-dialog {
  max-width: calc(100vw - 32px);
}

/* When align-center is used, cap the dialog height so the body scrolls
   instead of overflowing the viewport. */
.el-dialog.c-dialog.is-align-center {
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
}

.el-dialog.c-dialog.is-align-center .el-dialog__header,
.el-dialog.c-dialog.is-align-center .el-dialog__footer {
  flex-shrink: 0;
}

/* Body takes remaining vertical space and scrolls its own content
   vertically only. overflow-x is explicitly clipped — the spec coerces
   `overflow-x: visible` to `auto` whenever `overflow-y: auto`, which
   otherwise produces a phantom horizontal scrollbar even when content
   fits. */
.el-dialog.c-dialog.is-align-center .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

@media (max-width: 640px) {
  .el-dialog.c-dialog {
    width: calc(100vw - 32px) !important;
  }
}
</style>
